// extracted by mini-css-extract-plugin
export default {"tableRow":"UserList_tableRow__jD+OA","tableCell":"UserList_tableCell__xP0MD","ant-drawer-body":"UserList_ant-drawer-body__6skLV"};